import { configureStore, combineReducers } from "@reduxjs/toolkit";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import createWebStorage from "redux-persist/lib/storage/createWebStorage";

// import storage from "redux-persist/lib/storage";

import clientFilterReducer from "./reducers/clientFilterSlice";
import DashboardDropdownReducer from "./reducers/AssigneeTeamDropdownSlice";
import SharedLayoutReducer from "./reducers/SharedLayoutDataSlice";
import ticketTaskReducer from "./reducers/TicketTaskFilter";
import userfilterReducer from "./reducers/UserFilterSlice";

// Use sessionStorage instead of localStorage
const createSessionStorage = () => createWebStorage("session");
const storage = createSessionStorage();

const rootReducer = combineReducers({
  clientFilter: clientFilterReducer,
  DropdownList: DashboardDropdownReducer,
  SharedLayoutData: SharedLayoutReducer,
  ticketTaskFilter: ticketTaskReducer,
  userFilter: userfilterReducer,
});

// Configure persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "clientFilter",
    "DropdownList",
    "SharedLayoutData",
    "ticketTaskFilter",
    "userFilter",
  ], // Only persist these slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // redux-persist actions that need to be ignored
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// export const store = configureStore({
//   reducer: {
//     clientFilter: clientFilterReducer,
//     DropdownList: DashboardDropdownReducer,
//     SharedLayoutData: SharedLayoutReducer,
//     ticketTaskFilter: ticketTaskReducer,
//     userFilter: userfilterReducer,
//   },
// });
